import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetUserInfoComponent';

var styles = AppSettings.styles;

class UserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(){
        window.location.href = AppSettings.urlLogout;
    }
    render() {
        const {username, typeUser, ssn} = this.props;
        return (
            <>
                <div className="ub-intro-wrap">
                    <div id="ub-intro">
                        <div id="ub-welcome">Ciao<strong className="data-hj-suppress">{username}</strong></div>

                        <div id="ub-ultimo-accesso" title={AppSettings.lastLogin}>
                            Ultimo accesso: {AppSettings.lastLogin}               
                        </div>
                    </div>
                    <a onClick={this.handleLogout} title="Esci" className="mg-cta-site mg-btn-site mg-userbox-btn-logout">Esci<i className="fa-mg fa-mg-log-off"></i></a>
                </div>
                {/* {AppSettings['isPartner'] ?  */}
                    <div id="ub-profilo-utente">
                        {/* this.state.data.usernameDescription */}
                        <span className="ub-profilo-utente--titolo">Profilo</span>
                        <span className="ub-profilo-utente--importo">{typeUser}
                        </span>
                    </div>
                {/* : null} */}
                </>
        );
        // return (
        //    <div id="mg-dati-utente" className="mg-user-widget">
        //         <div id="mg-dati-profilo">
        //             <span className="mg-user-widget-titolo">{this.props.typeUser}</span>
        //             <span id="mg-nickname" className="mg-user-widget-desc">{this.props.username}</span>
        //         </div>
        //         <div id="mg-dati-cf">
        //             <span className="mg-user-widget-titolo">Codice fiscale</span>
        //             <span id="mg-cf" className="mg-user-widget-desc">{this.props.ssn}</span>
        //         </div>
        //         <div id="mg-dati-login">
        //             <span className="mg-user-widget-titolo">Ultimo accesso</span>
        //             <span id="mg-ultimo-accesso" className="mg-user-widget-desc">{AppSettings.lastLogin}</span>
        //         </div>
        //     </div>

        // );
    }
}

UserInfo.displayName = componentName;

// PropTypes validation
UserInfo.propTypes = {
    username: PropTypes.string.isRequired,
    typeUser: PropTypes.string.isRequired,
    ssn: PropTypes.string.isRequired
};

// default props
UserInfo.defaultProps = {
};

export default UserInfo;